import React, { FC, useMemo, useState } from 'react'
import ContactInfo from 'containers/VerticalPage/common/ContactInfo/ContactInfo'
import { tabsIds, getTabsList } from './utils'
import Tabs from 'components/common/Tabs'
import Overview from '../Overview/Overview'
import BusinessActivity from '../BusinessActivity/BusinessActivity'
import DetailsWrapper from 'containers/VerticalPage/common/DetailsWrapper/DetailsWrapper'
import styles from 'containers/VerticalPage/common/styles.scss'

const tabsList = getTabsList()

type TabContent = {
  [key in (typeof tabsIds)[keyof typeof tabsIds]]: JSX.Element | null
}

const Details: FC = () => {
  const [activeTab, setActiveTab] = useState<(typeof tabsIds)[keyof typeof tabsIds]>(tabsIds.OVERVIEW)

  const handleTabClick = (event: React.SyntheticEvent<Element, Event>, value: number) => {
    setActiveTab(value as (typeof tabsIds)[keyof typeof tabsIds])
  }

  const contentByTabMap: TabContent = useMemo(
    () => ({
      [tabsIds.OVERVIEW]: <Overview />,
      [tabsIds.BUSINESS_ACTIVITY]: <BusinessActivity />,
      [tabsIds.CONTACT_INFO]: <ContactInfo />,
      [tabsIds.TAX_RETURN]: null,
    }),
    [],
  )

  return (
    <DetailsWrapper>
      <div className={styles.tabsWrapper}>
        <Tabs
          tabs={tabsList}
          value={activeTab}
          disabledIds={[tabsIds.TAX_RETURN]}
          tabsClasses={{
            root: styles.root,
            flexContainer: styles.flexContainer,
          }}
          tabClasses={{
            root: styles.tabRoot,
            disabled: styles.tabDisabled,
          }}
          onChange={handleTabClick}
        />
      </div>
      {contentByTabMap[activeTab]}
    </DetailsWrapper>
  )
}

export default Details
